import React from 'react';
import { useParams } from 'react-router-dom';
import QuizContainer from '../components/QuizContainer';
import { quiz } from '../components/ComputerEssentialsQuiz';

const ComputerEssentialsQuizComponent = () => {
  const { id } = useParams();
  
  return (
    <QuizContainer 
      quizData={quiz}
      courseId={id}
    />
  );
};

export default ComputerEssentialsQuizComponent;